import React from 'react';
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";


class KpiCard extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.kpi.rate >= 1.25) {
            this.color = 'danger';
        }
        else if (this.props.kpi.rate <= 0.85) {
            this.color = 'warning';
        }
        else {
            this.color = 'success';
        }
        if (this.props.kpi.rate < 1) {
            this.rate = this.props.kpi.rate * 100;
        }
        else {
            this.rate = 100;
        }
    }


    render() {
        return (
            <Card
                size={'sm'}
                variant={'soft'}
                color={this.color}
                invertedColors
                sx={{
                    mx: 1,
                    flexGrow: 2,
                    border: this.props.activeCard+1 === this.props.kpi.period?1:0,
                }}
            >
                <CardContent
                    orientation="vertical"
                >
                    <Typography
                        level="body-sm"
                    >
                        {this.props.kpi.period}
                    </Typography>
                    <Typography
                        level="body-lg"
                    >
                        {this.props.kpi.value.toFixed(2)}
                    </Typography>
                    <Typography
                        level="body-sm"
                    >
                        {this.props.kpi.value_phase_true.toFixed(2)} + {this.props.kpi.value_phase_false.toFixed(2)}
                    </Typography>
                    <Typography
                        level="body-sm"
                    >
                        {this.props.kpi.pass_value.toFixed(2)}
                    </Typography>
                    <Typography
                        level="body-sm"
                    >
                        {this.props.kpi.diff.toFixed(2)}
                    </Typography>
                    <Typography
                        level="body-sm"
                    >
                        {(this.props.kpi.rate * 100).toFixed(1)} %
                    </Typography>
                </CardContent>
            </Card>
        )
    }
}

export default KpiCard